import { useEffect, useState, useRef } from "react";
import { useNavigate, useParams, generatePath } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import BottomBarIcons from "./BottomBarIcons";
import useGetClientId from "../hooks/useGetClientId";
// import Select from "react-select";
import {
  GET_ALL_PROPERTY_AND_ROLE_BASED_ON_CLIENT_ID,
  INVITE_MEMEBER_AND_ASSIGN_PROPERTY_V2,
} from "../api/apiPath";
import http from "../api/server";
import Toaster from "./common/Toaster";
import useGetCity from "../hooks/useGetCity";
import PhoneNumber from "./common/PhoneNumber";
import SidebarIcons from "./SidebarIcons";
const InviteNewMember = () => {
    const { clientNameParam } = useParams();
  const [hideSidebar, setHideSidebar] = useState(true);
  const [userObj, setUserObj] = useState({});
  // const [allProperty, setAllProperty] = useState(null);
  const [allRoles, setAllRoles] = useState(null);
  const [city, setCity] = useState(null);
  const clientObj = useGetClientId();
  const cityObj = useGetCity();
  const [validationFlag, setValidationFlag] = useState(false);
  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  useEffect(() => {
    setCity(cityObj?.cityList);
  }, [cityObj.cityList, cityObj.loading]);
  console.log(cityObj);
  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
  };
  // console.log("dataObj", dataObj);

  const navigate = useNavigate();
  useEffect(() => {
    setUserObj({ name: "Test User" });
  }, []);
  const handleGetAllPropertyByClinetID = async (clientId) => {
    try {
      const response = await http.get(
        GET_ALL_PROPERTY_AND_ROLE_BASED_ON_CLIENT_ID + "?clientId=" + clientId
      );
      if (response.status === 200) {
        // const extractedPropertyData = response.data.properties?.map((item) => ({
        //   value: item.propertyId,
        //   label: item.propertyName,
        // }));
        // setAllProperty(extractedPropertyData);
        setAllRoles(response.data.roles);
        // console.log("propertname", response.data.properties);
        console.log("role", response.data.roles);
      }
      if (response.status !== 200) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (clientObj.clientId) {
      handleGetAllPropertyByClinetID(clientObj.clientId);
    }
  }, [clientObj.clientId, clientObj.loading]);

  const [entries, setEntries] = useState([
    {
      id: 1,
      email: "",
      role: "",
      // propertyName: "",
      firstName: "",
      lastName: "",
      phoneNumber: "",
      city: "",
      userType: "",
      status: "active",
    }, // Initial entry
  ]);

  const addEntry = () => {
    const newId =
      entries.length > 0 ? Math.max(...entries.map((e) => e.id)) + 1 : 1;
    setEntries([
      ...entries,
      {
        id: newId,
        email: "",
        role: "",
        firstName: "",
        lastName: "",
        phoneNumber: "",
        userType: "",
        status: "active",
        city: "",
        // propertyName: "",
      },
    ]);
  };

  const removeEntry = (id) => {
    setEntries(entries?.filter((entry) => entry.id !== id));
  };

  const handleChange = (id, field, value) => {
    setEntries(
      entries?.map((entry) =>
        entry.id === id ? { ...entry, [field]: value } : entry
      )
    );
  };

  const firstNameRef = useRef({});
  const lastNameRef = useRef({});
  const emailRef = useRef({});
  const phoneRef = useRef({});
  const typeRef = useRef({});
  const cityRef = useRef({});
  const roleRef = useRef({});

  const handleSave = (event) => {
    event.preventDefault();
    console.log(entries);
    let isValid = true;
    setValidationFlag(false);
    entries.forEach((entry) => {
      const fRef = firstNameRef.current[entry.id];
      if (!(entry.firstName ?? "").trim()) {
        if (fRef) {
          fRef.style.border = "1px solid red";
        }
        isValid = false;
      } else {
        if (fRef) {
          fRef.style.border = "1px solid #ced4da";
        }
      }

      const lRef = lastNameRef.current[entry.id];
      if (!(entry.lastName ?? "").trim()) {
        if (lRef) {
          lRef.style.border = "1px solid red";
        }
        isValid = false;
      } else {
        if (lRef) {
          lRef.style.border = "1px solid #ced4da";
        }
      }

      const eRef = emailRef.current[entry.id];
      if (!(entry.email ?? "").trim()) {
        if (eRef) {
          eRef.style.border = "1px solid red";
        }
        isValid = false;
      } else {
        if (eRef) {
          eRef.style.border = "1px solid #ced4da";
        }
      }

      // const input = phoneRef.current[entry.id];
      // if (input) {
      //   if (!entry.phoneNumber) {
      //     input.parentNode.style.border = "1px solid red";
      //   } else {
      //     input.parentNode.style.border = "1px solid #ced4da";
      //   }
      // }

      const tRef = typeRef.current[entry.id];
      if (!(entry.userType ?? "").trim()) {
        if (tRef) tRef.style.border = "1px solid red";
        isValid = false;
      } else {
        if (tRef) tRef.style.border = "1px solid #ced4da";
      }

      const cRef = cityRef.current[entry.id];
      if (!(entry.city ?? "").trim()) {
        if (cRef) cRef.style.border = "1px solid red";
        isValid = false;
      } else {
        if (cRef) cRef.style.border = "1px solid #ced4da";
      }

      const rRef = roleRef.current[entry.id];
      if (!(entry.role ?? "").trim()) {
        if (rRef) rRef.style.border = "1px solid red";
        isValid = false;
      } else {
        if (rRef) rRef.style.border = "1px solid #ced4da";
      }
    });

    if (!isValid) {
      setValidationFlag(true);
      return;
    }

    handleInviteUser();
  };

  const handleInviteUser = async () => {
    console.log(entries);
    const payload = entries?.map((item) => ({
      clientId: clientObj.clientId,
      //propertyId: item?.propertyName?.value,
      roleId: item.role,
      userEmail: item.email,
      firstName: item.firstName,
      lastName: item.lastName,
      phoneNumber: item.phoneNumber,
      userType: item.userType,
      cityId: item.city,
      userStatus: item.status,
    }));
    const finalPayload = {
      assignments: payload,
    };

    try {
      const response = await http.post(
        INVITE_MEMEBER_AND_ASSIGN_PROPERTY_V2,
        finalPayload
      );

      if (response.status === 200) {
        setToastData({
          toastShow: true,
          toastType: "success",
          toastString: "Members are successfully invited",
        });
        setEntries([
          {
            id: 1,
            email: "",
            role: "",
            propertyName: "",
            firstName: "",
            lastName: "",
            phoneNumber: "",
            userType: "",
            status: "active",
            city: "",
          }, // Initial entry
        ]);
      }

      if (!response.status) {
        throw new Error(`HTTP error! status: ${response?.status}`);
      }
    } catch (error) {
      if (error.status === 400) {
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: error?.data?.title,
        });
      }
    }
  };
  return (
    <>
      <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />
      {userObj && (
        <div className="dashboard_body_main d-flex vh-100">
          {hideSidebar ? (
            <Sidebar
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          ) : (
            <SidebarIcons />
          )}
          {/* <Sidebar
            isCollapsed={hideSidebar}
            onToggle={() => setHideSidebar((v) => !v)}
          /> */}
          <div className="d-flex dashboard_body flex-column  w-100">
            <div className="col-sm-12 d-flex m-0 mt-3 align-items-center px-3">
              <div className="col-sm-6">
                <div className="text-start">
                  <p className="fs-3 fw-bold m-0">Invite New Member</p>
                  <p className="fs-6 m-0">Add a new member.</p>
                </div>
              </div>
            </div>

            <div className="col-sm-12 d-flex px-3 mt-3">
              <div className="card w-100 box_shadow">
                <div className="card-body">
                  {entries?.map((entry, index) => (
                    // eslint-disable-next-line react/jsx-key,
                    <>
                      <div>
                        <div
                          className="row w-150 align-items-center row-gap-2"
                          style={{
                            margin: "10px",
                            marginBottom: "20px",
                            padding: "15px",
                            border: "1px solid #ccc",
                          }}
                        >
                          <div  style={{ width: "50%" }}>
                            <label
                              htmlFor="firstname"
                              className="form-label text-start d-block fw-semibold"
                            >
                              First Name <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="text"
                              maxLength="50"
                              className="form-control"
                              id="firstname"
                              required
                              placeholder="First Name"
                              value={entry.firstName}
                              ref={(el) =>
                                (firstNameRef.current[entry.id] = el)
                              }
                              onChange={(e) =>
                                handleChange(
                                  entry.id,
                                  "firstName",
                                  e.target.value
                                )
                              }
                            />
                          </div>

                          <div  style={{ width: "50%" }}>
                            <label
                              htmlFor="firstname"
                              className="form-label text-start d-block fw-semibold"
                            >
                              Last Name <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="lastname"
                              maxLength="50"
                              className="form-control"
                              id="floatingInput"
                              placeholder="Last Name"
                              required
                              value={entry.lastName}
                              ref={(el) => (lastNameRef.current[entry.id] = el)}
                              onChange={(e) =>
                                handleChange(
                                  entry.id,
                                  "lastName",
                                  e.target.value
                                )
                              }
                            />
                          </div>
                          <div  style={{ width: "50%" }}>
                            <label
                              htmlFor="firstname"
                              className="form-label text-start d-block fw-semibold"
                            >
                              Email <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="email"
                              className="form-control"
                              id="floatingInput"
                              placeholder="Enter email address"
                              value={entry.email}
                              ref={(el) => (emailRef.current[entry.id] = el)}
                              onChange={(e) =>
                                handleChange(entry.id, "email", e.target.value)
                              }
                              required
                            />
                          </div>

                          <div
                            className="react-tele-input"
                            style={{ width: "50%" }}
                          >
                            <label
                              htmlFor="firstname"
                              className="form-label text-start d-block fw-semibold"
                            >
                              Mobile Number{" "}
                           
                            </label>
                            <PhoneNumber
                              setPhoneNumber={(e) => {
                                handleChange(
                                  entry.id,
                                  "phoneNumber",
                                  e.mobileNumber
                                );
                              }}
                              phoneNumber={{
                                mobileNumber: entry.phoneNumber,
                                mobileCountryCode: "",
                              }}
                              inputRef={(el) =>
                                (phoneRef.current[entry.id] = el)
                              }
                             
                            />

                            {/* <input
                              type="phoneNumber"
                              className="form-control"
                              id="floatingInput"
                              placeholder="sample@example.com"
                              value={entry.phoneNumber}
                              onChange={(e) =>
                                handleChange(
                                  entry.id,
                                  "phoneNumber",
                                  e.target.value
                                )
                              }
                              required
                            /> */}
                            {/* <label htmlFor="floatingInput">
                              Phone no<span style={{ color: "red" }}>*</span>
                            </label> */}
                          </div>
                          {/* <div className="col-sm-3">
                          <div className="form-floating">
                            <Select
                              options={allProperty}
                              value={entry.propertyName}
                              required
                              onChange={(selected) => {
                                handleChange(
                                  entry.id,
                                  "propertyName",
                                  selected ? selected : ""
                                );
                              }}
                             placeholder={
                          <span>
                          Select Properties<span style={{ color: "red" }}>*</span>
                          </span>
                          }
                              isClearable
                              menuPortalTarget={document.body}
                              styles={{
                                container: (base) => ({
                                  ...base,
                                  width: "100%",
                                }),
                                control: (base) => ({
                                  ...base,
                                  minHeight: "58px",
                                }),
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                              }}
                            />
                          </div>
                        </div> */}
                          <div  style={{ width: "50%" }}>
                            <label
                              htmlFor={`userType-${entry.id}`}
                              className="form-label text-start d-block fw-semibold"
                            >
                              Type<span style={{ color: "red" }}>*</span>
                            </label>
                            <select
                              className="form-select"
                              name="role"
                              id={`userType-${entry.id}`}
                              aria-label="Floating label select example"
                              value={entry.userType} // <-- binds to state
                              ref={(el) => (typeRef.current[entry.id] = el)}
                              onChange={(e) =>
                                handleChange(
                                  entry.id,
                                  "userType",
                                  e.target.value
                                )
                              }
                            >
                              <option value="">Select Type</option>
                              <option value="Internal Staff">
                                Internal Staff
                              </option>
                              <option value="Contractor">Contractor</option>
                            </select>
                          </div>
                          <div  style={{ width: "50%" }}>
                            <label
                              htmlFor={`city-${entry.id}`}
                              className="form-label text-start d-block fw-semibold"
                            >
                              City<span style={{ color: "red" }}>*</span>
                            </label>
                            <select
                              className="form-select"
                              name="city"
                              id={`city-${entry.id}`}
                              aria-label="Floating label select example"
                              value={entry.city}
                              ref={(el) => (cityRef.current[entry.id] = el)}
                              onChange={(e) =>
                                handleChange(entry.id, "city", e.target.value)
                              }
                            >
                              <option value="">Select City</option>
                              {city?.map((data) => (
                                <option key={data?.cityId} value={data?.cityId}>
                                  {data.cityName}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div style={{ width: "50%" }}>
                            <label
                              htmlFor={`role-${entry.id}`}
                              className="form-label text-start d-block fw-semibold"
                            >
                              Role<span style={{ color: "red" }}>*</span>
                            </label>
                            <select
                              className="form-select"
                              name="role"
                              id={`role-${entry.id}`}
                              aria-label="Floating label select example"
                              value={entry.role}
                              ref={(el) => (roleRef.current[entry.id] = el)}
                              onChange={(e) =>
                                handleChange(entry.id, "role", e.target.value)
                              }
                            >
                              <option value="">Select a Role</option>
                              {allRoles?.map((data) => (
                                <option key={data?.roleId} value={data?.roleId}>
                                  {data.roleName}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div  style={{ width: "50%" }}>
                            <label
                              htmlFor="floatingSelect"
                              className="form-label text-start d-block fw-semibold"
                            >
                              Status<span style={{ color: "red" }}>*</span>
                            </label>
                            <select
                              className="form-select"
                              name="role"
                              id="floatingSelect"
                              aria-label="Floating label select example"
                              value={entry.status}
                              onChange={(e) =>
                                handleChange(entry.id, "status", e.target.value)
                              }
                            >
                              <option value="active">Active</option>
                              <option value="archived">Archived</option>
                            </select>
                          </div>
                        </div>

                        {/* <hr /> */}
                      </div>
                      <div
                        className="col-sm-12 col-auto gap-3"
                        style={{ textAlign: "end" }}
                      >
                        <button
                          type="button"
                          className={`btn btn-light rounded ${
                            !(entries.length - 1 === index) ? "displayNone" : ""
                          }`}
                          style={{
                            fontSize: "12px",
                            background: "white",
                            color: "red",
                          }}
                          onClick={addEntry}
                          disabled={
                            entries.length === 0
                              ? false
                              : !(entries.length - 1 === index)
                          }
                        >
                          <i className="fa-solid fa-plus icon_rounded"></i>
                        </button>
                        <button
                          type="button"
                          className="btn btn-light rounded"
                          style={{
                            fontSize: "12px",
                            background: "white",
                            color: "red",
                          }}
                          onClick={() => removeEntry(entry.id)}
                          disabled={entries.length === 1 ? true : false}
                        >
                          <i className="fa-solid fa-minus icon_rounded"></i>
                        </button>
                      </div>
                    </>
                  ))}
                </div>
              </div>
            </div>
            <div className="col-sm-12 d-flex px-3 mt-3">
              <div className="card w-100 " style={{ border: "none" }}>
                <div className="card-body">
                  <div>
                    {" "}
                    {validationFlag && (
                      <small style={{ color: "red" }} className=" mb-1">
                        * Please fill all required fields
                      </small>
                    )}
                  </div>
                  <div className="d-flex align-items-center justify-content-end">
                    <button
                      type="button"
                      className="cardbutton me-3 px-5"
                      onClick={() => {
                        navigate(
                          generatePath("/client/:clientNameParam/members", {
                                  clientNameParam,
                                })
                        );
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn-primary  px-5"
                      onClick={handleSave}
                    >
                      Save Member
                    </button>
                  </div>
                </div>
              </div>
            </div>
            
            <Toaster
              show={toastData.toastShow}
              toastType={toastData.toastType}
              title={toastData.toastString}
              theme={"dark"}
              position="top-center"
              closeButton={() => {
                closeButton();
              }}
            />
          </div>
          <Footer />
<div className="bottom-bar-spacing"></div>
<BottomBarIcons />
        </div>
      )}
    </>
  );
};

export default InviteNewMember;
